"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { segmentGroupAnatomy } from "@chakra-ui/react/anatomy"

const segment = defineSlotRecipe({
  className: "hydrologiq-segment",
  slots: segmentGroupAnatomy.keys(),

  variants: {
    variant: {
      // Bordered group with the selected option filled (Alert Configuration design)
      hydrologiq_segmented: {
        root: {
          "--segment-radius": "none",
          backgroundColor: "card",
          border: "1px solid {colors.divider}",
          borderRadius: "5px",
          boxShadow: "none",
          overflow: "hidden",
          width: "fit-content",
          padding: 0,
          gap: 0,
        },
        item: {
          height: "auto",
          px: "18px",
          py: "8px",
          fontSize: "16px",
          lineHeight: "24px",
          color: "primary",
          backgroundColor: "card",
          borderLeft: "1px solid {colors.divider}",
          _first: { borderLeft: "none" },
          _before: { display: "none" },
          _checked: {
            backgroundColor: "#39aed2",
            color: "white !important",
            fontWeight: 600,
          },
          _hover: { cursor: "pointer" },
          _disabled: { opacity: 0.5, cursor: "not-allowed" },
        },
        indicator: { display: "none" },
      },
      hydrologiq_icon: {
        root: {
          "--segment-radius": "none",
          backgroundColor: "transparent",
          border: "1px solid #0bc5ea",
          boxShadow: "none",
          width: "fit-content",
        },
        item: {
          fontSize: "15px",

          _checked: {
            borderColor: "#39aed2",
            backgroundColor: "#39aed2",
            color: "white !important",
          },

          _before: {
            display: "none",
          },

          _disabled: {
            opacity: 0.5,
            cursor: "not-allowed",
          },

          _hover: {
            cursor: "pointer",
            borderColor: "#0bc5ea !important",
            backgroundColor: "#0bc5ea !important",
            color: "white !important",
          },
        },
      },
      hydrologiq: {
        root: {
          "--segment-radius": "none",
          backgroundColor: "background",
          border: "none",
          boxShadow: "none",
          fontWeight: 600,

          "&::before": {
            display: "none",
          },
          pb: "3px",
        },
        item: {
          borderBottom: "3px solid",
          borderColor: "#a9a9a9",
          backgroundColor: "background",
          fontSize: "15px",

          _checked: {
            color: "active !important",
            borderColor: "active !important",
          },

          _disabled: {
            opacity: 0.5,
            cursor: "not-allowed",
          },

          _before: {
            display: "none",
          },

          _hover: {
            cursor: "pointer",
            color: "#0bc5ea",
            borderColor: "#0bc5ea",
          },
        },
        indicator: {
          boxShadow: "none",
          border: "none",
        },
        itemControl: {
          boxShadow: "none",
          border: "none",
        },
      },
    },
  },
})

export default segment
